// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-captcha-img-wrapper {\n\t\tmax-height: 60px;\n    max-width: 222px;\n}\n.form-captcha-img-wrapper img {\n\t\tmax-width: 100%\n}\n", ""]);
// Exports
module.exports = exports;
